import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';

import { HttpClient } from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';
import {ListReference} from '../index';
import {Observable, of} from 'rxjs';


@Injectable({   providedIn: 'root' })
export class MotivationsService extends DaoGeneric<ListReference> {
  private url = `${environment.baseUrl}/dar/motivations/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
}
